import React, {useState} from 'react';
import Dropzone from 'react-dropzone';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { LabelText } from '../../Language';
import { isNullOrUndefined } from 'util';
import config from '../../../common/const/config';

const UploadFile = (props) => {
    const [selectedFile, setSelectedFile] = useState(props.selectedRevenueCashRegisterFile);
    const [error, setError] = useState();

    const invalidFile = (errorCode) => {
        setSelectedFile(undefined);
        setError(errorCode);
    }

    const selectFile = (acceptedFiles) =>{
        if(acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            const maxFileSize=config.maxFileSize;
            if(file.size) {
                if(props.isCashRegister && file.size > maxFileSize) {
                    invalidFile("filesize");
                } else {
                    setSelectedFile(acceptedFiles[0]);
                    setError(undefined);
                }
            } else {
                invalidFile("validfile");
            }
        } else {
            invalidFile("validfile");
            setSelectedFile(undefined);
        }
    }

    const onUploadClickHandler = () => {
        if(selectedFile) {
            if(props.isCashRegister && (!isNullOrUndefined(props.selectedRowIndex))) {
                props.handlerOnUploadClick(props.selectedRowIndex, props.selectedRevenue, selectedFile, selectedFile.name, props.UserId);
            } else {
                props.handlerOnUploadClick(selectedFile);
            }
        }
    }

    const onDeleteFileClickHandler = () => {
        props.handlerOnDeleteFileClick(props.selectedRowIndex, props.selectedRevenue);
        setSelectedFile(undefined);
    }

    const deleteFileTooltip = (
        <Tooltip id="deleteFile">
          <LabelText tid="delete" />
        </Tooltip>
    );

    return (
        <div>
            {props.weeklyStartDate && props.weeklyEndDate && 
            <div className="file-types"><span><LabelText tid="period" /></span>
            <span>{' :' + props.weeklyStartDate + '-' + props.weeklyEndDate}</span>
            </div>}
            <div className="file-types"><span>{<LabelText tid={props.allowedFileType} />}</span></div>
            {props.isCashRegister && <div className="file-types"><span><LabelText tid="maxfilesize" /></span></div>}                                                                    
            <Dropzone onDrop={(ev)=>selectFile(ev)}                   
                     accept={props.acceptFileType}>
                        {({getRootProps, getInputProps})=>(
                             <div {...getRootProps({className: "dropzone file-upload-box"})}>
                                 <input {...getInputProps()} multiple={false} />
                                 <p><LabelText tid="draganddrop" /></p>
                             </div>
                           )
                        }
            </Dropzone>
            {(selectedFile || (props.selectedRevenue && (props.selectedRevenue.userCashRegisterFileName                
                || props.selectedRevenue.userIntakeBookFileName))) && <div className="selected-file-name">
               {
                   props.isCashRegister ? (<div className="cash-register-file-container">
                                            <div className="filename-container">
                                                <strong><LabelText tid="file" />: 
                                                <span>
                                                    {
                                                       selectedFile ? selectedFile.name : (props.selectedRevenue.userCashRegisterFileName ? 
                                                       props.selectedRevenue.userCashRegisterFileName : props.selectedRevenue.userIntakeBookFileName)
                                                    }
                                                </span>
                                            </strong></div>
                                            {!props.isModifying && <div className="delete-icon-container"><OverlayTrigger placement="right" overlay={deleteFileTooltip}>
                                                <a href="#" onClick={()=>onDeleteFileClickHandler()} ><LabelText tid="delete" /></a> 
                                            </OverlayTrigger></div>}
                                        </div>)  
                                     : selectFile && <strong><LabelText tid="file" />: <span>{selectedFile.name}</span></strong>
               }
            </div>}
            {error && <div className="Errormsg-invalidfile">
                <span><LabelText tid={error} /></span>
            </div>}
            <div className="upload-btn-container">            
                <button className= {!selectedFile ? "btn btn-success upload-btn disable-success-btn"
                 : "btn btn-success upload-btn" }
                disabled={!selectedFile} 
                onClick={onUploadClickHandler}><LabelText tid="upload" /></button>
            </div>
        </div>
    );
}

export default UploadFile;
